(function($){
	$(document).ready(function() {
	
		// console.log('cur-footer.js loaded!');

		$('.cur-footer .navigation .nav-list h3').on('click', function(event) {
			if (!$(this).parent().hasClass('open')) {
				$(this).parent().addClass('open');
				$(this).siblings('ul').slideDown(250, function() {

				});
			} else {
				$(this).siblings('ul').slideUp(200, function() {
					$(this).parent().removeClass('open');
				});
			}
		});

		$(document).on("click", function(event) {
			if (window.innerWidth >= 768) { return; }
			const $target = $(event.target);
			if ($target.closest('.navigation .nav-list').length) return;
			$('.cur-footer .navigation .nav-list ul').stop(true,true).slideUp(200, function() {
				$(this).parent().removeClass('open');
			});

		});

	});
})(jQuery);